module.exports = __webpack_public_path__ + "img/banner.2ce8c622.svg";